import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	padding: 0 20px 20px;
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 12px;
`;

export const HeaderRow = styled.div`
	display: grid;
	grid-template-columns: 184px repeat(2, 1fr);
	grid-template-rows: 1fr;

	@media (max-width: 992px) {
		grid-template-columns: 90px 1fr 1fr;
	}
`;

export const HeaderPlace = styled.div`
	padding: 29px 20px;
	font-size: 20px;
	line-height: 27px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};

	@media (max-width: 992px) {
		padding: 16px 7px 16px 13px;
		font-size: 16px;
		line-height: 22px;
	}
`;

export const HeaderParticipant = styled.div`
	padding: 29px 20px;
	font-size: 20px;
	line-height: 27px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};

	@media (max-width: 992px) {
		padding: 16px 12px;
		font-size: 16px;
		line-height: 22px;
	}
`;

export const HeaderPrize = styled.div`
	padding: 29px 20px;
	font-size: 20px;
	line-height: 27px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};

	@media (max-width: 992px) {
		padding: 16px 12px;
		font-size: 16px;
		line-height: 22px;
	}
`;

export const WinnerTable = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const PaginationRow = styled.div`
	margin-top: 16px;
	width: 100%;
	display: flex;
	justify-content: end;
`;

export const PaginationButtonsRow = styled.div`
	display: flex;
	gap: 2px;
`;

export const PaginationButton = styled.button<{ $isActive?: boolean }>`
	width: 34px;
	height: 34px;
	border-radius: 50%;

	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	font-size: 14px;
	line-height: 20px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	svg {
		width: 16px;
		height: 16px;
	}

	path {
		fill: ${({ theme }) => theme.colors.text.body};
	}

	&:hover {
		background-color: ${({ theme }) => theme.colors.transparent.light10};
		color: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	${({ $isActive }) =>
		$isActive &&
		css`
			background-color: ${({ theme }) => theme.colors.transparent.light10};
			color: ${({ theme }) => theme.colors.text.alwaysWhite};
		`}
`;
